import { motion } from 'framer-motion';
import SectionWrapper from '../ui/SectionWrapper';

const About = () => {
    const textVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] },
        },
    };

    return (
        <SectionWrapper id="about" className="bg-bg-secondary/30">
            <div className="max-w-3xl mx-auto">
                <motion.h2
                    className="text-3xl md:text-4xl font-heading font-bold mb-8 text-center"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={textVariants}
                >
                    <span className="text-gradient">About Me</span>
                </motion.h2>

                <motion.div
                    className="space-y-6 text-text-secondary text-lg leading-relaxed"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.2,
                            },
                        },
                    }}
                >
                    <motion.p variants={textVariants}>
                        After graduating from Babeș-Bolyai University of Law and practicing law for three years as an Attorney registered at the Bar of Cluj-Napoca, I decided to pivot towards the tech industry, driven by a lifelong interest. This transition from law to web development has given me a unique perspective, blending analytical thinking with technical skills.
                    </motion.p>

                    <motion.p variants={textVariants}>
                        Now a dedicated web developer, I've been self-educating and engaging in challenging projects to deepen my expertise. My venture, Destroyed Secure, combines my legal background with technology, specializing in data destruction and security solutions.
                    </motion.p>
                </motion.div>
            </div>
        </SectionWrapper>
    );
};

export default About;
